import type { ItemTypeValue, SalesExplorerResult } from "./types";

export interface ExportLabels {
  date: string;
  item: string;
  itemType: string;
  owner: string;
  pet: string;
  appointmentType: string;
  itemCount: string;
  quantity: string;
  unitPrice: string;
  value: string;
}

function formatItemType(type: ItemTypeValue | null): string {
  if (type === "SERVICO") return "Serviço";
  if (type === "PRODUTO") return "Produto";
  if (type === "PACOTE") return "Pacote";
  return "";
}

export function buildExplorerExportRows(
  result: SalesExplorerResult,
  labels: ExportLabels,
): Record<string, string | number>[] {
  if (result.format === "item") {
    return result.rows.map((row) => ({
      [labels.date]: row.occurredAt,
      [labels.item]: row.itemName,
      [labels.itemType]: formatItemType(row.itemType),
      [labels.pet]: row.petName ?? "",
      [labels.owner]: row.ownerName ?? "",
      [labels.quantity]: row.quantity,
      [labels.unitPrice]: row.unitPrice,
      [labels.value]: row.lineTotal,
    }));
  }

  return result.rows.map((row) => {
    const appointment = {
      [labels.date]: row.occurredAt,
      [labels.pet]: row.petName ?? "",
      [labels.owner]: row.ownerName ?? "",
      [labels.appointmentType]: row.appointmentType ?? "",
      [labels.itemCount]: row.itemCount,
    };

    if (row.items.length === 0) {
      return { ...appointment, [labels.value]: row.value };
    }

    return {
      ...appointment,
      [labels.item]: row.items.map((item) => item.itemName).join("; "),
      [labels.itemType]: row.items.map((item) => formatItemType(item.itemType)).join("; "),
      [labels.quantity]: row.items.map((item) => item.quantity).join("; "),
      [labels.unitPrice]: row.items.map((item) => item.unitPrice).join("; "),
      [labels.value]: row.value,
    };
  });
}
